import { VOCategory, VOGalleryList, VOGalleryMedia, VOMedia } from "../model/DataStructure.js";
import { MediaItem } from "./MediaItem.js";
import { AbstractContentView } from "./views/AbstractContentView.js";

export class Gallery extends AbstractContentView {
    //VOGalleryList, galleryIndex, mediaIndex
    public onClose = e5.Signal.create<[VOGalleryList, number, number]>();

    private _galleryList: VOGalleryList = null;
    private _galleryIndex: number = 0;
    private _mediaIndex: number = 0;
    private _title: HTMLDivElement;
    private _subtitle: HTMLDivElement;
    private _description: HTMLDivElement;
    private _mediaItem: MediaItem;

    constructor() {
        super();
        this.element.classList.add("gallery");
        this.element.classList.remove("active");
        this.element.innerHTML = `
        <div class="media-container"></div>
        <div class="text-container scrollbar vert">
            <div class="text-title"></div>
            <div class="text-subtitle"></div>
            <div class="text-description"></div>
        </div>`;

        this._title = this.element.querySelector(".text-title");
        this._subtitle = this.element.querySelector(".text-subtitle");
        this._description = this.element.querySelector(".text-description");
        this._mediaItem = new MediaItem({
            element: this.element.querySelector(".media-container")
        })

        var swipe = new e5.Swipe(this.element);
        swipe.onSwipe.add((direction) => {
            if (direction === "left")
                this.next();
            else if (direction === "right")
                this.prev();
        });
    }

    public reset(): void {
        console.warn("Not implemented!");
    }

    public open(): void {
        console.warn("Not implemented!");
    }

    public async create(category: VOCategory): Promise<boolean> {
        console.warn("Not implemented!");
        return true;
    }

    public handleClickClose(): boolean {
        console.warn("Not implemented!");
        return true;
    }

    public next(): void {
        var media = this.getMedia();
        if (!media)
            return;
        var next = media.nextValid;
        if (!next)
            return;

        //Prevent next gallery switch
        //Prevent around the corner
        if (next.gallery != media.gallery
            || next.index < media.index) {
            return;
        }

        this._mediaIndex = next.index;
        this._galleryIndex = next.gallery.index;
        this.updateMedia(true);
    }

    public prev(): void {
        var media = this.getMedia();
        if (!media)
            return;
        var prev = media.prevValid;
        if (!prev)
            return;

        //Prevent prev gallery switch
        //Prevent around the corner
        if (prev.gallery != media.gallery
            || prev.index > media.index) {
            return;
        }

        this._mediaIndex = prev.index;
        this._galleryIndex = prev.gallery.index;
        this.updateMedia(true);
    }

    public close(): void {
        this.active = false;
        this.onClose.dispatch(this._galleryList, this._galleryIndex, this._mediaIndex);
        this._mediaItem.clear();
    }

    public openGallery(galleryList: VOGalleryList, galleryIndex: number, mediaIndex: number): void {
        this.active = true;
        this._galleryList = galleryList;
        this._galleryIndex = galleryIndex;
        this._mediaIndex = mediaIndex;
        this.updateMedia(true);
    }

    private getMedia(galleryIndex: number = this._galleryIndex, mediaIndex: number = this._mediaIndex): VOGalleryMedia {
        if (!this._galleryList)
            return null;

        var gallery = this._galleryList.media[galleryIndex];
        if (!gallery) {
            return null;
        }

        var media = gallery.list_item_medias[mediaIndex];
        if (!media) {
            return null;
        }

        return media;
    }

    private updateMedia(immediate: boolean = false): void {
        var media = this.getMedia();
        if (!media) {
            this.onSelectEntry.dispatch(null);
            console.warn("Could get get media from VOGalleryList. GalleryIndex:", this._galleryIndex, "MediaIndex:", this._mediaIndex);
            return;
        }

        // var isFirst = media.gallery.index === 0 && media.index === 0;
        // var isLast = media.gallery.index === this._galleryList.media.length - 1 && media.index === media.gallery.validCount - 1;
        // var isSingle = this._galleryList.media.length <= 1 && media.gallery.validCount <= 1;
        // this.showArrows = {
        //     left: isSingle ? "none" : (isFirst ? "skip" : "normal"),
        //     right: isSingle ? "none" : (isLast ? "skip" : "normal"),
        //     index: media.index,
        //     total: media.gallery.list_item_medias.length
        // }

        var isFirst = media.index === 0;
        var isLast = media.index === media.gallery.validCount - 1;
        var isSingle = this._galleryList.media.length <= 1 && media.gallery.validCount <= 1;
        this.showArrows = {
            left: isSingle ? "none" : (isFirst ? "none" : "normal"),
            right: isSingle ? "none" : (isLast ? "none" : "normal"),
            index: media.index,
            total: media.gallery.list_item_medias.length
        }

        var gallery = this._galleryList.media[this._galleryIndex];
        if (gallery.list_item_use_text_first_media)
            this.onSelectEntry.dispatch(media.breadcrumbTitle || media.title || gallery.breadcrumbTitle || gallery.list_item_title);
        else {
            this.onSelectEntry.dispatch(gallery.breadcrumbTitle || gallery.list_item_title || media.title || media.breadcrumbTitle);
        }

        if (immediate) {
            this.element.classList.add("no-transition");
        }

        this._mediaItem.load(media);

        var title = media.title;
        var subtitle = media.subtitle;
        var description = media.description;

        var hasText = title || subtitle || description;

        //TODO: put into the VOConfig... ???
        // var fallbackToGalleryText = true;

        // if (fallbackToGalleryText && !hasText && media.gallery) {
        //     title = media.gallery.list_item_title;
        //     subtitle = media.gallery.list_item_subtitle;
        //     description = media.gallery.list_item_description;

        //     hasText = title || subtitle || description;
        // }

        this._title.classList.toggle("hidden", !Boolean(title));
        this._subtitle.classList.toggle("hidden", !Boolean(subtitle));
        this._description.classList.toggle("hidden", !Boolean(description));

        if (hasText) {
            this._title.innerHTML = title;
            this._subtitle.innerHTML = subtitle;
            this._description.innerHTML = description;
        } else {

        }

        this.element.classList.toggle("no-text", !hasText);

        if (immediate) {
            window.getComputedStyle(this.element).opacity;
            this.element.classList.remove("no-transition");
        }
    }
}